export default __webpack_public_path__ + "static/media/routing-number.1b74430e.svg";